import { styled } from '@mui/material/styles';
import { Typography, Paper, Chip, FormHelperText } from '@mui/material';
import { emphasize } from '@mui/system/colorManipulator';

export const RootContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  '& > div': {},
  '& > div > div > label': {
    padding: '0 4px',
    top: 0,
    left: -3,
    zIndex: 2
  },
  '&.invalid > div > div > label': {
    color: '#FF4635'
  },
  '&.invalid fieldset': {
    borderColor: '#FF4635'
  },
  '&.invalid fieldset:hover': {
    borderColor: '#FF4635'
  },
  '& > div :before': {
    display: 'none'
  },
  '& > div :after': {
    display: 'none'
  }
}));

export const InputContainer = styled('div')({
  '&&': {
    display: 'flex',
    padding: '6px 8px',
    minHeight: 54,
    height: 'auto'
  }
});

export const ValueContainerDiv = styled('div', {
  shouldForwardProp: prop => prop !== 'overviewPage'
})(({ overviewPage }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1,
  alignItems: 'center',
  overflowY: 'auto',
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  },
  '& > div': {
    marginLeft: 5
  },
  '& > div[role=button]': {
    marginLeft: 2
  },
  ...(overviewPage && { maxHeight: 80 })
}));

export const StyledChip = styled(Chip, {
  shouldForwardProp: prop => !['isFocused', 'isChipOverview'].includes(prop)
})(({ theme, isFocused, isChipOverview }) => ({
  margin: '4px 2px',
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      cursor: isChipOverview ? 'default' : 'pointer',
      color: '#878787',
      marginLeft: theme.spacing(0.5)
    }
  },
  ...(isFocused && {
    backgroundColor: emphasize(
      theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  })
}));

export const MessageTypography = styled(Typography)(({ theme }) => ({
  padding: `${theme.spacing()} ${theme.spacing(2)}`
}));

export const SingleValueTypography = styled(Typography)({
  fontSize: 16
});

export const PlaceholderTypography = styled(Typography)({
  position: 'absolute',
  left: 13,
  fontSize: 16
});

export const MenuPaper = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  zIndex: 3,
  marginTop: theme.spacing(),
  left: 0,
  right: 0
}));

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: theme.spacing(1.75),
  marginRight: theme.spacing(1.75)
}));
